import { styled } from '@mui/material';
import { Footer } from 'src/components/Footer';
import { ConfigurationProvider } from 'src/providers/Configuration';
import { MainTemplate } from 'src/templates/MainTemplate';
import { ManageHeader } from './ManageHeader';
import { ManageNav } from './ManageNav';

interface ManageProductTemplateProps {
  children: React.ReactNode;
  page: 'product-overview' | 'kits' | 'sales-bom' | 'parts-categories';
  pageTitle?: string;
  pageDescription?: React.ReactNode;
  hideProductName?: boolean;
}

export function ManageTemplate({
  children,
  page,
  pageTitle,
  pageDescription,
  hideProductName,
}: Readonly<ManageProductTemplateProps>) {
  return (
    <MainTemplate data-testid="create-new-product-page">
      <SectionSpacing>
        <ConfigurationProvider>
          <ManageNav page={page} />
          <ManageHeader subTitle={pageTitle} description={pageDescription} hideProductName={hideProductName} />
          {children}
        </ConfigurationProvider>
      </SectionSpacing>
      <Footer />
    </MainTemplate>
  );
}

export const SectionSpacing = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
`;
